/**
 * 批量任务执行结果列表组件
 * 用于显示批量设置任务中每个设备的执行情况
 */
import React, { useEffect } from 'react';
import { List, Tag } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, SyncOutlined, ClockCircleOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { useBatchTaskEnums } from '@/utils/useBatchTaskEnums';

interface ExecutionResult {
  id: number;
  sn: string; // 设备SN号
  deviceBatchTaskId: number;
  stat: number; // 执行状态
  resultData: any;
  retryCount: number; // 重试次数
  createTime: string; // 创建时间
  updateTime: string; // 更新时间
  statDesc: string; // 状态描述
}

interface TaskExecutionResultListProps {
  data?: ExecutionResult[]; // 执行结果数据
}

const TaskExecutionResultList: React.FC<TaskExecutionResultListProps> = ({ data }) => {
  console.log('TaskExecutionResultList data:', data);
  // 获取枚举数据
  const { statuses } = useBatchTaskEnums();

  // 获取状态标签
  const getStatusTag = (stat: number) => {
    const status = statuses.find(item => item.value === stat);
    const statusLabel = status?.label || '未知状态';

    // 根据状态值设置不同的颜色和图标
    let color = 'default';
    let icon = null;

    if (statusLabel.includes('成功') || statusLabel.includes('完成')) {
      color = 'success';
      icon = <CheckCircleOutlined />;
    } else if (statusLabel.includes('失败') || statusLabel.includes('错误')) {
      color = 'error';
      icon = <CloseCircleOutlined />;
    } else if (statusLabel.includes('处理中') || statusLabel.includes('执行中')) {
      color = 'processing';
      icon = <SyncOutlined spin />;
    } else if (statusLabel.includes('待') || statusLabel.includes('等待')) {
      color = 'default';
      icon = <ClockCircleOutlined />;
    }

    return <Tag color={color} icon={icon}>{statusLabel}</Tag>;
  };


  return (
    <div style={{ marginTop: 16 }}>
      <div style={{ marginBottom: 12, fontSize: 14, fontWeight: 500 }}>
        设备执行情况：
      </div>
      <List
        bordered
        dataSource={data || []}
        locale={{ emptyText: '暂无执行结果' }}
        renderItem={(item) => (
          <List.Item>
            <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center', gap: 16 }}>
              <div style={{ flex: 1 }}>
                <span style={{ fontWeight: 500, marginRight: 8 }}>设备SN：</span>
                <span style={{ color: '#595959' }}>{item.sn}</span>
              </div>
              <div style={{ flex: 1, textAlign: 'center' }}>
                {getStatusTag(item.stat)}
              </div>
              <div style={{ flex: 1, textAlign: 'center' }}>
                <span style={{ color: '#8c8c8c', fontSize: 12 }}>重试次数：{item.retryCount}</span>
              </div>
              <div style={{ flex: 1.5, textAlign: 'right', color: '#8c8c8c', fontSize: 12 }}>
                <div>创建：{dayjs(item.createTime).format('YYYY-MM-DD HH:mm:ss')}</div>
                <div>更新：{dayjs(item.updateTime).format('YYYY-MM-DD HH:mm:ss')}</div>
              </div>
            </div>
          </List.Item>
        )}
      />
    </div>
  );
};

export default TaskExecutionResultList;
